import TCAISearch from "./script";
import TCAIFilters from "./filters";
import TCAIInfinityScroll from "./infinityscroll";
import TCAISort from "./sort";
import TCAIQuickView from "./quickview";

TCAISearch.initalization();
TCAIFilters.initialization();
TCAISort.initialization();
TCAIInfinityScroll.initialization();
TCAIQuickView.initializaton();